import React, { useState } from 'react';

interface DropdownProps {
  title: string;
  description: string;
}

const SupportDropdown = ({ title, description }: DropdownProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const toggle = () => {
    setOpen(!open);
  };

  return (
    <div className="w-full">
      <button onClick={toggle} className="flex justify-between items-center w-full">
        <span className={`text-lg font-bold text-left transition-opacity sm:text-xl`}>{title}</span>

        <span
          className={`${
            open ? 'rotate-90' : 'rotate-0'
          }   material-symbols-outlined dark:text-blue-100 transition-all text-xl sm:text-3xl`}
        >
          chevron_right
        </span>
      </button>
      {open && <p className="mt-5 w-full text-left">{description}</p>}
    </div>
  );
};

export default SupportDropdown;
